export const baseUrl = 'https://api.themoviedb.org/3'  // base url of tmdb site 
export const api_Key = '2b1ff2ae7b358ff45560338820d512bb'  // API Key
export const image_Url = 'https://image.tmdb.org/t/p/original'